import { createContext, useState } from 'react';

type SelectPlatarform = string;

type PropsPlataformContext = {
  selectPlataform: SelectPlatarform,
  setSelectPlataform: React.Dispatch<React.SetStateAction<SelectPlatarform>>;
};

const DEFAULTVALUEPLATAFORM = {
  selectPlataform: 'analise/unidades',
  setSelectPlataform: () => {},
};

const SelectPlataformContext = createContext<PropsPlataformContext>(DEFAULTVALUEPLATAFORM);

export default SelectPlataformContext;
